import Vue from 'vue'
import { clone } from 'ramda'

/**
 * @typedef AppState
 * @property {string} [min] Min year to search Reports
 * @property {string} [max] Max year to search Reports
 */

/** @type {AppState} */
const state = Vue.observable({})

export const ready = new Promise(resolve => {
	document.addEventListener('DOMContentLoaded', () => {
		if (!('__INITIAL_STATE__' in BX)) return resolve()

		for (const [key, value] of Object.entries(BX.__INITIAL_STATE__)) {
			Vue.set(state, key, clone(value))
		}

		resolve()
	}, { once: true })
}).then(() => state)

export default state
